import {useMutation, useQueryClient} from '@tanstack/react-query'

import {
    downloadRentalAssetImportTemplate,
    importRentalAssetsCsv,
    previewRentalAssetImport,
} from './api'

export function useDownloadRentalAssetImportTemplate() {
    return useMutation({
        mutationFn: () => downloadRentalAssetImportTemplate(),
    })
}

export function usePreviewRentalAssetImport() {
    return useMutation({
        mutationFn: (file: File) => previewRentalAssetImport(file),
    })
}

export function useImportRentalAssetsCsv() {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (file: File) => importRentalAssetsCsv(file),
        onSuccess: (result) => {
            if (result.importedCount > 0) {
                void queryClient.invalidateQueries({queryKey: ['rental-assets']})
            }
        },
    })
}
